import Link from 'next/link';
import { HTMLProps } from 'react';
import styles from './AccountActions.module.css';

interface Props extends HTMLProps<HTMLAnchorElement> {
  label: string;
  href: string;
  external?: boolean;
}

const AccountAction = ({ label, href, external = false, ...props }: Props) => {
  if (external) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.Button}
        {...props}
      >
        {label}
      </a>
    );
  }
  return (
    <Link href={href}>
      <a className={styles.Button} {...props}>
        {label}
      </a>
    </Link>
  );
};

export default AccountAction;
